import dayjs from '~/timeInit';

import type { Dayjs } from '~/services/TimeService';
import { SYDNEY_TIMEZONE } from '~/services/TimeService';

const DATE_ONLY_FORMAT = 'YYYY-MM-DD';

function createSydneyDay(value: string | Dayjs): Dayjs {
  return dayjs.tz(dayjs(value).format(DATE_ONLY_FORMAT), DATE_ONLY_FORMAT, SYDNEY_TIMEZONE);
}

export function parseSydneyDateOnly(value?: string | null): Dayjs {
  return dayjs.tz(value ?? '', DATE_ONLY_FORMAT, SYDNEY_TIMEZONE);
}

export function formatSydneyDateOnly(value: Dayjs): string {
  return value.tz(SYDNEY_TIMEZONE).format(DATE_ONLY_FORMAT);
}

export function parseCommissionRuleBoundaryToSydneyDate(value?: string | null): Dayjs {
  return dayjs(value).tz(SYDNEY_TIMEZONE);
}

export function serializeCommissionRuleBoundaryDate(value: Dayjs): string {
  return createSydneyDay(value).format(DATE_ONLY_FORMAT);
}
